import * as catalogos from './catalogos/zh1';
export const locale = {
  lang: 'zh1',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB':'正在保存更改...',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG':'問題',
      'TITULO_TAB_TRAD':'翻譯',
      'TITULO_TAB_PREV':'預覽',
      'TAB_PREGUNTAS':{
        'CLA':'鑰匙:',
        'BTN_CONFIG_PLA':'模板配置',
        'SLI_VER_US_EMPRE':'以業務用戶身份查看',
        'ETI_INSTNES':'您可以按照以下步驟加載模板中包含的問題列表:',
        'ETI_INST1':'下載模板',
        'ETI_INST2':'根據格式填寫問題模板',
        'ETI_INST3':'使用問題加載模板',
        'ETI_INST_NOT':'注意:您可以以一般方式或在每個可用部分內上傳問題列表',
        'ETI_SECCI_NOT_GRU':'此部分沒有組',
        'INST_AGRE_GRUP':'使用以下按鈕添加一組問題',
        'BTN_AGRE_GRUP':'添加群組',
        'INST2_AGRE_GRUP':'您以後可以向該組添加問題',
        'ETI_DETEC_CAMB_PLAN':'在原始模板中檢測到更改',
        'BTN_GUAR_CAMB':'保存更改',
        'BTN_GUAR_CAMB_NEW_PLAN':'另存為新模板',
        'MAT_DESC_PLAN':'下載模板',
        'ETI_LIS_GRUP':'組列表',
        'MAT_CHIP_PRE_EXTR_SI':'其他可用問題:',
        'MAT_CHIP_PRE_EXTR_NO':'您不能再添加其他問題',
        'MAT_CHIP_PRE_EXTR_ILIM':'無限的額外問題',
        'ETI_INST_COLO_CUR':'將光標置於任何組上以查看可用的操作',
        'MAT_EDIT_NOMB_SECC':'編輯組的名稱',
        'MAT_DELET_SECC':'刪除該組',
        'MAT_AGRE_SECC_ARRI':'在上方添加群組',
        'ETI_SECC_SIN_PREG':'這個小組沒有問題',
        'ETI_SECC_INST_COLO_CUR':'將光標放在問題上以查看可用的操作',
        'ETI_PREG_OPCIO_EDITA':'可選的可編輯問題',
        'ETI_PREG_OPCIO_NO_EDITA':'可選的不可編輯的問題',
        'ETI_PREG_OPCIO_OBLI_EDITA':'必填項',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA':'強制性不可編輯問題',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'必填問題答案',
        'MAT_FALT_OPC_RESP':'缺少響應選項',
        'ETI_FALT_OPC_RESP':'問題缺少答案選項',
        'MAT_NO_GUAR_CATA':'尚未保存在目錄中',
        'ETI_PREG_NO_GUAR_CATA':'問題尚未保存在目錄中',
        'MAT_CHIP_TIP':'類型',
        'MAT_TOOL_DETA_PREG':'問題詳細信息',
        'BTN_EDIT_PREG':'查看詳細信息',
        'MAT_TOOL_MOVE_PREG':'提出這個問題',
        'BTN_EDIT_ES_PREG':'編輯此問題',
        'BTN_DELE_ES_PREG':'刪除此問題',
        'MAT_TOOL_AGRE_PREG_ARRI':'在上方添加問題',
        'MAT_TOOL_AGRE_PREG_ABAJ':'在下方添加問題',
        'MAT_LABE_SELE_VERSI_PREG':'選擇問題的版本',
        'MAT_LABE_TEX_PREG':'問題文本',
        'MAT_LABE_TEX_PREG_KEY':'特殊問題鍵',
        'ETI_CUE_SIG_ACC_PREG':'依靠這個問題的以下動作',
        'MAT_CARD_MAES':'主目錄',
        'ETI_DETEC_CAMB_TEX_PREG':'在問題文本中檢測到更改',
        'MAT_TOOL_YET_NO_GUA_CAT':'尚未保存在目錄中',
        'ETI_ESTA_PREG_NO_GUAR_CATA':'此問題未保存在目錄中',
        'ETI_GUAR_PREG':'保存問題',
        'ETI_GUAR_CAMB':'保存更改',
        'MAT_SLIDE_PREG_EDIT':'可編輯的問題',
        'MAT_SLIDE_PREG_DELET':'可移動問題',
        'MAT_SLIDE_PREG_REQUI':'必填項',
        'ETI_AGRE_PREG':'添加問題',
        'ETI_GRUP_PREG ':'問題組',
        'ETI_SECC_ESP ':'特節',
        'ETI_KEY_NO_EMPL':'未使用特殊節鍵',
        'ETI_FALT_KEY_SEC_ESP':'*缺少特殊部分鍵',
        'ETI_CLA_GRU_LIS':'關鍵詞:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG':'提出問題',
          'ETI_INTS_SELEC_SECC_MOVE':'選擇您要將問題移至的組',
          'ETI_NOT_PREG_MOVE1':'注意:',
          'ETI_NOT_PREG_MOVE2':'該問題將移至所選組的末尾',
          'BTN_CANCELAR':'取消',
          'ETI_CONFI_PLAN':'模板配置',
          'ETI_DATOS_PLAN':'模板數據:',
          'ETI_NOMB':'名稱:',
          'ETI_SECC':'團體',
          'ETI_PREG':'問題:',
          'ETI_NOT_CONF_CONT_SECC':'注意：這些控件的配置適用於以業務類型用戶在顯示模式下顯示的模板中的所有組和問題',
          'ETI_PERMI_SECC':'組權限',
          'ETI_AGRE_SECC_NEW':'添加新組',
          'ETI_MOVE_SECC':'移動組',
          'ETI_EDIT_TITU':'編輯標題',
          'ETI_DELET_SECC':'刪除群組',
          'ETI_NOMB_OBL_GRUP_NEW':'新組中的必填名稱',
          'ETI_ENABLE_SEC_ESP': '啟用特殊問題/部分',
          'ETI_PERMIS_PREG':'每個組的問題權限：',
          'ETI_AGRE_PREG_NEW':'添加新問題',
          'ETI_AGRE_PREG_CATAL':'添加目錄問題',
          'ETI_MOVE_PREGS':'提出問題',
          'ETI_EDIT_PREG':'編輯問題',
          'ETI_DELET_PREG':'刪除問題',
          'ETI_REQUIRED':'是否需要答案？',
          'ETI_PREG_NEW_MAX':'新的最大問題數',
          'ETI_PREG_NEW_MAX_4ALL':'練習次數 4All',
          'ETI_MAX_PREG_NEW':'最大新問題',
          'ETI_ENABLE_AUDIOS': '啟用音軌',
          'ETI_DEMOGRAF':'人口統計',
          'ETI_ABIER':'打開',
          'ETI_PRAC4ALL':'Practices 4All',
          'ETI_ADICIO':'其他',
          'BTN_SAL':'退出',
          'ETI_INST_AGRE_PREG_CAT':'添加目錄問題',
          'ETI_BUSC_SELECC_PREG_PLAN':'在此屏幕中,您可以搜索並選擇要添加到模板的問題',
          'TITULO_TAB_LIS_PREG':'問題清單',
          'TITULO_TAB_BUSC_PREG':'搜索問題',
          'TITULO_TAB_PREG_SELEC':'選擇的問題',
          'PASO_1':'步驟1',
          'PASO_2':'第2步',
          'ETI_VER_LIS_PREG_SELEC_3_PEST':'您可以在此窗口的第三個標籤中看到所選問題的列表',
          'ETI_SELEC_PREG_LIS_CAT':'從目錄中的列表中選擇問題',
          'ETI_SELEC_PREG':'選擇問題',
          'ETI_YA_SELEC_NUM_MAX_PREG':'您已經選擇了模板中允許的最大額外問題數',
          'ETI_PREG_MS_UNA_VERS':'此問題有多個版本,請選擇您要查看的版本',
          'ETI_SELEC_VERS':'選擇版本',
          'ETI_PREG_SELECCIONDA':'選擇的問題:',
          'ETI_AGRE_PREG':'添加問題',
          'ETI_OK_AGRE_PREG_LIST':'<b>問題已添加到問題列表中</ b>,您可以選擇並添加更多問題以添加到模板中',
          'ETI_OK_AGRE_PREG_LIST2':'您也可以在此窗口的第三個標籤中看到所選問題的列表',
          'ETI_ESCR_TEXT_BUSC':'輸入您要搜索的問題的文本',
          'ETI_BUSC_PREG_COINC':'搜索匹配的問題',
          'ETI_NO_ENCO_PREG':'對於輸入的文本未發現任何問題,請嘗試其他文本',
          'ETI_RESUL_BUSC':'搜索結果',
          'BTN_ELEG':'選擇',
          'ETI_REGRE_RESUL':'返回結果',
          'ETI_PREG_SELECC_MOMEN':'到目前為止選擇的問題列表',
          'MAT_TOOL_ELEG_VERSI':'選擇其他版本',
          'MAT_TOOL_ELI_VERSI':'刪除版本',
          'BTN_REGRES':'返回',
          'BTN_ELIG_VERSI':'選擇版本',
          'MAT_TOOL_QUITA_LIS':'從列表中刪除',

          'BY_TEXT': '按問題文本',
          'BY_KEYWORDS': '按關鍵字',
          'QUESTION_TEXT': '問題文本',
          'QUESTION_KEYWORDS': '關鍵詞',
          'QUESTION_HINT': '關鍵字必須以字符 <b> # </b> 開頭並用逗號分隔'
        },
        'DETALLE':{
          'ETI_DETALL_PREG':'問題詳細信息',
          'ETI_LAB_TEX_PREG':'問題文本',
          'PLACE_HOL_TEX_PREG':'問題文本',
          'MAT_TOOL_EDIT_PREG':'編輯此問題',
          'MAT_CARD_OPC_RESP':'響應選項',
          'MAT_TOOL_EDIT_RESP':'編輯此答案',
          'MAT_TOOL_DELET_RESP':'刪除此答案',
          'ETI_AGRE_OPCI_RESP':'添加答案選項',
          'ETI_SELEC_VERSI_PREG':'選擇問題的版本',
          'ETI_CUENT_SIG_ACC_PREG':'依靠這個問題的以下動作',
          'ETI_DETEC_CAMB_TEXMAES':'主目錄',
          'ETI_CATA_MAES':'主目錄',
          'ETI_DETEC_CAMB_TEX_PREG':'在問題文本中檢測到更改',
          'ETI_DETEC_CAMB_TEX_RESP':'檢測到響應選項的更改',
          'ETI_PREG_NO_GUAR_CATA':'此問題未保存在目錄中',
          'ETI_GUAR_PREG':'保存問題',
          'ETI_GUAR_CAMB':'保存更改',
          'ETI_BORR_PREGUN':'刪除問題',
          'ETI_DELET_PREG':'刪除問題',
          'MAT_CARD_PLAN':'模板',
          'MAT_SLIDE_PREG_EDIT':'可編輯的問題',
          'MAT_SLIDE_PREG_DELET':'可移動問題',
          'MAT_SLIDE_PREG_REQUI':'必填項',
          'BTN_REGRES':'返回',
          'ETI_NEW_PREG':'新問題',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE':'輸入文字並選擇新問題的答案類型',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP':'編寫文本並為新問題添加答案選項',
          'ETI_TIP_PREG':'問題類型',
          'ETI_TIP_RESP':'響應類型',
          'ETI_TIP_FORM':'問題格式',
          'ETI_PREG_ESP_FLD': '特殊問題鍵',
          'ETI_PREG_ESP_HNT': '輸入特殊問題的密鑰',
          'BTN_CANCELAR':'取消',
          'BTN_CONTINU':'繼續',
          'ETI_NEW_PRAC_4ALL':'New 4All練習',
          'ETI_INST_NAME_DESC_4ALL':'輸入新的4All練習的名稱和描述',
          'ETI_LABE_NAME':'實踐名稱',
          'ETI_LABE_DESC':'做法說明',
          'ETI_CLAVE_DEMOGR':'從字符開始，寫一個或多個識別問題的關鍵字',
          'ETI_CLAVE_DEMOGR1':'並以逗號分隔',
          'ETI_CLAVE_DEMOGR2': '注意：僅當關閉此窗口時將此問題保存到目錄中時，才會存儲關鍵字',
          'ETI_PALA_CLAVE_DEMOGR':'關鍵字',
          'ETI_SELE_TIPO_DEMOGR':'選擇與新問題相對應的人口統計類型',

          'MAT_TOOL_CONFIG_RESP':'配置這個答案',
          'MAT_SLIDE_RESP_EDIT':'可編輯答案',
          'MAT_SLIDE_RESP_DELET':'可移動答案',
          'MAT_SLIDE_RESP_TIPO_OTRO':'輸入“其他”',
          'MAT_TOOL_NEWVERS_PREG':'另存為新版本',
          'NOTA_PREG_MOD': '注意：此問題的文本已被修改，如果您願意，可以將其另存為新版本',
          'RESPUESTA_TIPO_OTRO':' - 回答類型“其他”',

          'TIPO_DEMOGRAFICO':'人口統計類型',
          'SIN_TIPO_DEMOGRAFICO':'沒有為此問題選擇人口統計類型'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP':'新模板',
          'TEXT_MOD_GUA_CAM_TEMP':'輸入新模板的名稱',
          'BTN_CAN_MOD_GUA_CAM_TEMP':'取消',
          'BTN_AGRE_MOD_GUA_CAM_TEMP':'添加',
          'RETUR_MOD_GUA_CAM_TEMP':'您尚未輸入名稱的文字',
          'SUCC_TEXT_MOD_GUA_PLAN':'新模板已正確保存',
          'TITU_MOD_GUA_CAM_TEMP2':'您要保存對原始模板所做的更改嗎？ 警告:下次使用此模板分配產品時,將包括到目前為止所做的所有更改',
          'BTN_CONTI_MOD_GUA_CAM_TEMP':'繼續',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG':'對原始模板的更改已正確保存',
          'MENS_1':'您想在此部分中添加什麼樣的問題？',
          'MENS_2':'您有兩個選擇',
          'BTN_NEW':'New',
          'BTN_D_CATA':'來自目錄',
          'TITU_MOD_CARG_LIS_COLAB_P1':'此文件包含',
          'TITU_MOD_CARG_LIS_COLAB_P2':'部分總計',
          'TITU_MOD_CARG_LIS_COLAB_P3':'問題。警告:如果繼續加載此文件,將替換當前存在的問題和組',
          'TITU_TEX_MOD_CARG_LIS_COLAB':'您有兩個選擇',
          'BTN_AGRE_PREGU':'添加問題',
          'BTN_CANC_PREGU':'放棄問題',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB':'問題已正確添加',
          'TEXT_MOD_NOT_CARG_LIS_COLAB':'問題已被放棄',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB':'所選文件有錯誤,無法加載。再次檢查所有行的排列順序是否正確,然後重試',
          'BTN_OK':'確定',
          'TITU_MOD_NEW_SECC':'新欄目',
          'TEXT_MOD_NEW_SECC':'輸入新部分的名稱',
          'TEXT_SUCC_PREG_AGRE':'問題已正確添加',
          'TITU_MOD_EDI_SECC':'修改節名稱',
          'TEXT_SUCC_MODIF_SECC':'部分名稱已正確更改',
          'TEXT_SUCC_MODIF_GRU':'組名已修改',
          'TITU_MOD_DELE_SECC1':'確定要刪除此部分嗎？',
          'BTN_SI':'是',
          'BTN_NO':'否',
          'TITU_MOD_DELE_SECC2':'本節包含一個或多個問題,您想對這些問題做什麼？',
          'BTN_DELE_PRE':'刪除問題',
          'BTN_CAN_TRAN':'將它們轉移到上一部分',
          'TEX_SUCC_DELE_PREG':'該部分已正確刪除',
          'TITU_AGRE_NEW_PREG':'新問題',
          'TEXT_AGRE_NEW_PREG':'輸入新問題的文本',
          'TITU_EDIT_PREG_MOD_PREG':'修改問題',
          'TITU_EDIT_PREG_MOD_PRACT':'修改慣例',
          'TITU_EDIT_PREG_MOD_DESCRI':'修改描述',
          'TEXT_MOD_PREG_SUCC':'問題已正確修改',
          'TITU_2_OPCIO':'您有兩個選擇來保存此修改',
          'BTN_CONF_ACT':'更新問題',
          'BTN_CANC_NEW':'作為新問題',
          'BTN_CONF_ACT_VERSION':'更新這個版本',
          'BTN_CANC_NEW_VERSION':'作為新版本',
          'TEX_CONFIR_MSG1':'問題已正確修改',
          'TEX_CONFIR_MSG2':'實踐已正確修改',
          'TEX_CONFIR_MSG3':'描述已正確修改',
          'TITU_DELE_PREG':'確定要刪除此問題嗎？',
          'TEXT_SUCC_PREG':'問題已正確刪除',
          'TITU_MOD_DELE_SECC_TEMPLA':'確定要刪除此部分嗎？',
          'TITU_MOD_DELE_SECC_TEMPLA2':'本節包含一個或多個問題,您想對這些問題做什麼？',
          'TEX_SUCC_GUAR_PREG_':'問題已正確保存',
          'TITU_MOD_DELE_PREG_MG':'確定要從目錄中刪除問題嗎？警告:此操作無法撤消,並且該問題在當前包含該操作的模板中不再可用',
          'TEX_CONFIR_MSG4_DELE':'該問題已正確從目錄中刪除',
          'TEX_GUAR_TRADU_SUCC':'翻譯已正確保存',
          'TEX_MOVE_PREG_SECC':'問題已移至另一部分',
          'TEX_SUCC__PRAC_4ALL':'實踐已正確添加',
          'MOD_MOD_AGRE_PREG':'該問題已正確添加到列表中',
          'MOD_MOD__MODIF_VERSI_PREG':'問題的版本已正確更改',
          'MOD_MOD__QUIT_PREG_LIST':'問題的版本已正確更改',
          'TITU_NUE_OPC_RESP':'新答案選項',
          'TEXT_NUE_OPC_RESP':'輸入新選項的文字',
          'TEXT_NO_TEXT_PREG':'您尚未輸入問題的文字',
          'TEXT_AGRE_OPC_RESP':'已正確添加響應選項',
          'MOD_EDIT_RESP':'修改答案選項',
          'MOD_EDIT_MODIF_OPC_RESP':'答案選項已正確修改',
          'MOD_COMFIR_DELE_OPC_RESP':'確定要刪除此答案選項嗎？',
          'MOD_SUCC_DELE_OPC_RESP':'答案選項已被正確刪除',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP':'在不為問題添加答案選項的情況下無法繼續進行',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP':'如果沒有先寫下問題的文本,就不能繼續進行',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP':'如果沒有選擇問題類型,您將無法繼續',
          'MOD_AGRE_PREG_DONDE_GUARDAR': '在添加新問題之前，是否要將其保存到目錄中？ 還是您只想在本調查中使用它？',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': '通過將其保存到目錄中，可以根據需要將其提供給其他調查。',
          'BOT_DONDE_GUARDAR_1': '保存到目錄',
          'BOT_DONDE_GUARDAR_2': '僅將其保存到此調查',
          'MOD_SIN_TAGS': '您尚未為該問題輸入至少一個關鍵字',
          'MOD_SIN_OPC_RESP': '您尚未為該問題輸入至少兩個答案選項',
          'MOD_SIN_TIPO_DEMO': '您尚未為此問題選擇受眾特徵類型',
          'MOD_SIN_CLA_ESPE': '您尚未添加特殊問題的關鍵',
          'MOD_SIN_TIPO_RESP': '您必須選擇問題的答案類型才能繼續',
          'MOD_RESP_DELOK': '答案選項已成功刪除',
          'MOD_RESP_DELCATOK': '該問題已成功從目錄中刪除',
          'MOD_RESP_ADDTAGOK': '關鍵字已正確添加到問題',
          'MOD_RESP_ADDTAGERR': '關鍵字不是以＃字符開頭',
          'MOD_RESP_DELTAGOK': '關鍵字已從問題中正確刪除',
          'MOD_SAVE_CAMBIOS_PREGCAT': '保存對此目錄問題的更改時，所做的修改將另存為問題文本和答案選項的新版本（如果適用）。\n\n你想繼續嗎？',
          'MOD_SAVE_CAMB_PREGCAT': '你想在哪裡存儲對問題文本的修改？',
           'BTN_MOD_SAVE_CAMB_PREGCAT': '僅在本次調查中',
           'BTN_MOD_ACTUA_PREGCAT': '更新目錄中的問題',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG':'正在加載',
        'TEXT_NO_ELEG_ADIC':'未選擇其他語言',
        'ERR_MSG_TRADU':'翻譯尚未完成',
        'TEX_IDIO_PRIN':'主要語言',
        'TEX_NAM_GRUP':'組名',
        'TEX_TRAD_NAM':'輸入名稱的翻譯',
        'TEX_NO_TRAD_TEXT':'您尚未輸入翻譯文本',
        'TEX_TEX_PREG':'問題文本',
        'TEX_TEX_RESP':'回复文字',
        'TEX__TRA_PREG':'輸入問題的翻譯內容',
        'TEX__TRA_RESP':'輸入答案的譯文',
        'GUAR_TRA_NAM':'正在保存名稱翻譯,請稍候',
        'GUAR_TRA_PRE':'正在保存問題翻譯,請稍候',
        'GUAR_TRA_RES':'正在保存答案選項的翻譯,請稍候',
        'INGR_TEX_PRAC_4ALL':'練習',
        'INGR_TEX_TRADU_PRAC_4ALL':'輸入練習翻譯',
        'INGR_TEX_DESCR_4ALL':'說明',
        'INGR_TEX_TRADU_DESCR_4ALL':'輸入描述的譯文',
        'GUAR_TRADU_PRAC':'正在保存練習翻譯，請稍候...',
        'GUAR_TRADU_DESCR':'正在保存描述翻譯，請稍候...'

      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI':'選擇一種語言以顯示問題的翻譯',
        'ETI_SIN_TRAD_PRE':'¡翻譯文本丟失！',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': '添加音軌',
          'CHANGE': '替換音軌'
        },
        'SUBTITULO': '您可以通過以下選項之一將音軌與此問題相關聯',
        'BOTONES': {
          'RESTART': '返回開始',
          'NEXT': '下一個',
          'BACK': '回去',
          'ACEPTAR': '接受',
          'CANCELAR': '取消'
        },
        'OPCIONES': {
          'GOOGLE': '生成自動旁白',
          'RECORD': '錄製旁白',
          'ARCHIVO': '上傳 mp3 文件',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': '您可以編輯文本以生成自動旁白',
            'INPUT': '問題文本',
            'INPUT_TT': '寫問題文本',
            'NOTA': '注意：修改此文本不會修改調查中的問題文本'
          },
          'RECORD': {
            'TITULO': '單擊“錄製”按鈕開始從麥克風錄製音頻',
            'NOTA': '注意：您可能需要向瀏覽器授予使用麥克風的權限',
            'START': '開始錄音',
            'STOP': '錄製音頻，點擊按鈕停止錄製'
          },
          'ARCHIVO': {
            'INPUT': '單擊此處或將音頻文件拖動到此區域以加載它',
            'NOTA': '注意：僅支持 MP3 格式'
          },
          'PREVIEW': {
            'GENERANDO': '正在生成音頻，請稍等',
            'TITULO': '您可以在下方收聽加載的音頻',
            'NOTA_1': '如果要將此音軌保存到問題中，請單擊“確定”按鈕',
            'NOTA_2': '如果要更改音頻，請單擊後退按鈕',
            'NOTA_3': '如果要更改加載的音頻類型，請單擊“返回開始”按鈕'
          }
        },
        'MODALES': {
          'DESCARTAR': '你確定要回到上一步嗎？ \n\n 當前曲目將被丟棄',
          'ARCHIVO_MAL': '上傳的文件不是音軌',
          'GUARDANDO': '將音軌保存到問題中，稍等片刻',
          'BORRAR': '您確定要刪除與此問題相關的音軌嗎？',
          'CONFIRMAR_BORRAR': '要確認，請在文本框中輸入紅色代碼：\n\n',
          'BORRADO_OK': '問題的音軌已正確刪除',
          'CODIGO_MAL': '輸入的代碼與紅色標示的不匹配',
          'AGREGANDO_PREGUNTAS': '部分問題正在添加中，請稍等'
        },
        'PREVIOS': {
          'TITULO': '相關音軌',
          'SIN_AUDIO': '沒有關聯的音軌',
          'SIN_AUDIO_FORALL': '沒有音軌',
          'ADD_AUDIO': '添加音軌',
          'CON_AUDIO': '這個問題有一個音軌',
          'PLAY': '播放音頻',
          'CHANGE': '替換音頻',
          'DELETE': '刪除音頻',
          'AUDIO_STATEMENT_1': '聲明 1 的音軌',
          'AUDIO_STATEMENT_2': '聲明 2 的音軌',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': '特別版塊',
        'SUBTITULO_1': '這組問題可以建立一個特殊的版塊，這個組的問題只會顯示給密碼相同的合作者',
        'SUBTITULO_2': '注意：在合作者上傳步驟中，必須至少有一個合作者與此特殊部分相關聯',
        'TIPOS': {
          'NORMAL': '普通款',
          'ESPECIAL': '特別版塊'
        },
        'CAMPO': {
          'TITULO': '部分鍵',
          'TOOLTIP': '寫下這部分的key',
          'HINT': '沒空間了',
          'ACEPTAR': '接受'
        },
        'MODALES': {
          'CONFIRM_DISABLE': '如果禁用特殊部分，當前標記為特殊部分的問題組將轉換為普通問題組，此更改將適用於所有問題部分。 \n\n 確定要繼續嗎？',
          'DISABLE_OK': '所有找到的特殊部分都轉換為正常問題組',
          'SIN_CLAVE': '要保存特殊部分，您需要輸入該部分的密鑰'
        }
      }
    },
  }
};
